import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=c045407a&scoped=true&"
import script from "./TransactionsList.vue?vue&type=script&lang=js&"
export * from "./TransactionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c045407a",
  null
  
)

export default component.exports